import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f8a86a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "column column-80" }
const _hoisted_4 = { class: "column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeading = _resolveComponent("TheHeading")!
  const _component_FilterList = _resolveComponent("FilterList")!
  const _component_LinkList = _resolveComponent("LinkList")!
  const _component_SelectedRegexp = _resolveComponent("SelectedRegexp")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TheHeading, { class: "header" }),
        _createVNode(_component_FilterList, {
          class: "filter-list",
          filters: _ctx.filters,
          onCheck: _cache[0] || (_cache[0] = ($event: any) => (_ctx.checked = $event))
        }, null, 8, ["filters"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_LinkList),
        _createVNode(_component_SelectedRegexp, { checked: _ctx.checked }, null, 8, ["checked"])
      ])
    ])
  ]))
}